import { PagedRequestType, PagedResultsType } from "../../../types/PagedResults";
import { ClassSubjectTeachersType } from "../../../types/Teacher";
import { get } from "../../../utils/axios-config";
import { TEACHERS_CLASSES_SUBJECTS } from "../../../utils/constants";

export const getAssignedTeachersClassesSubjects = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
        ...(data?.IdClass ? { IdClass: data.IdClass } : {}),
        ...(data?.IdCourse ? { IdCourse: data.IdCourse } : {}),
        ...(data?.IdFaculty ? { IdFaculty: data.IdFaculty } : {}),
        ...(data?.idScientificArea ? { idScientificArea: data.idScientificArea } : {}),
    });
    const url = `${TEACHERS_CLASSES_SUBJECTS}?${queryParams.toString()}`;
    return await get<PagedResultsType<ClassSubjectTeachersType>>(url)
};